"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexStreamDestination = void 0;
var tslib_1 = require("tslib");
var hex_content_destination_1 = require("./hex-content-destination");
var HexStreamDestination = (function (_super) {
    tslib_1.__extends(HexStreamDestination, _super);
    function HexStreamDestination(importer, dataStream) {
        var _this = _super.call(this, importer) || this;
        _this.dataStream = dataStream;
        return _this;
    }
    HexStreamDestination.prototype.processBinCharCore = function (ch) {
        this.dataStream.push(ch);
    };
    HexStreamDestination.prototype.getNumberArray = function () {
        var _this = this;
        var firstPosition = true;
        var currentValue = 0;
        var result = [];
        this.dataStream.forEach(function (char) {
            if (char == ' ')
                return;
            var hex = _this.importer.hexToInt(char, false);
            if (firstPosition)
                currentValue = hex << 4;
            else {
                currentValue += hex;
                result.push(currentValue);
                currentValue = 0;
            }
            firstPosition = !firstPosition;
        });
        return result;
    };
    return HexStreamDestination;
}(hex_content_destination_1.HexContentDestination));
exports.HexStreamDestination = HexStreamDestination;
